import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './SalesOrders.frontend.types'

@Injectable({ providedIn: 'root' })
export class SalesOrders_execute_rule_outbound_order_processing_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { rule_id: string, order_ids: number[], options: { processing_strategy_workflow_code: string, cartonization_strategy_workflow_code: string, expand_order_line_kits?: boolean }, parallel_requests?: number }): Promise<{ orders_succeeded?: number[], orders_failed_count?: number, logs?: string[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.rule_id)) {
      $missingRequiredInParams.push('\'rule_id\'');
    }
    if (isNil($inParams.order_ids)) {
      $missingRequiredInParams.push('\'order_ids\'');
    }
    if (isNil($inParams.options)) {
      $missingRequiredInParams.push('\'options\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

